export default __webpack_public_path__ + "static/media/IconDesc_GasMaskFilter.256.dee872c8.png";